<template>
  <b-sidebar
    id="add-new-sales-type-sidebar"
    :visible="isAddNewSalesTypeSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-sales-type-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Add New Sales Type</h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <!-- BODY -->
      <div class="p-2">
        <sales-type-form :form-data.sync="formData" :loading="isSubmitting" @submit="onSubmit" />
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { BSidebar } from 'bootstrap-vue';
import { ref, computed } from '@vue/composition-api';
import Ripple from 'vue-ripple-directive';
import store from '@/store';
import SalesTypeForm from './SalesTypeForm.vue';

export default {
  name: 'SalesTypeListAddNew',
  components: {
    BSidebar,
    SalesTypeForm,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewSalesTypeSidebarActive',
    event: 'update:is-add-new-sales-type-sidebar-active',
  },
  props: {
    isAddNewSalesTypeSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const businessID = computed(() => store.state.user.businessID);
    const userID = computed(() => store.state.user.userID);

    // Loading state
    const isSubmitting = ref(false);
    const formData = ref(null);

    const resetForm = () => {
      formData.value = null;
    };

    const onSubmit = async () => {
      console.log('=== Sales Type Add New On Submit', JSON.stringify(formData.value, null, 2));

      isSubmitting.value = true;

      try {
        formData.value.businessID = businessID.value;

        await store.dispatch('fbr-invoice-sales-type/addSalesType', formData.value);

        // Show success toast
        store.dispatch('app/showToast', {
          title: 'Success',
          text: 'Sales Type added successfully',
          variant: 'success',
        });

        emit('refetch-data');
        emit('update:is-add-new-sales-type-sidebar-active', false);
      } catch (error) {
        console.error('Error adding sales type:', error);

        // Show user-friendly error message
        let errorMessage = 'Error adding sales type. Please try again.';

        if (error.message && error.message.includes('User ID not found')) {
          errorMessage = 'Session expired. Please login again.';
        } else if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }

        // Show error toast
        store.dispatch('app/showToast', {
          title: 'Error',
          text: errorMessage,
          variant: 'danger',
        });
      } finally {
        isSubmitting.value = false;
      }
    };

    return {
      formData,
      onSubmit,
      isSubmitting,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
#add-new-sales-type-sidebar {
  .content-sidebar-header {
    padding: 1rem 1.5rem !important;
  }
}
</style>
